/** A display-name suggestion, never an identity or ownership assertion. */
export function suggestedProfileName(search) {
  const name=new URLSearchParams(search).get('name')?.trim();
  return name&&name.length<=32&&!/[\u0000-\u001f\u007f]/.test(name)?name:null;
}
